import { createApi } from '@reduxjs/toolkit/query/react';
import { METHOD } from '../../constants/constant';
import { HANDOVER_ACCESS_END_POINTS } from '../../constants/constant';
import { customHandoverBaseQuery } from '../customBaseQuery';

export interface UpdateHandoverAccessRequest {
  handoverId: string;
  permittedUser?: string;
  blockedUser?: string;
  unblockedUser?: string;
  allow?: 'read' | 'write';
}

export interface UpdateHandoverAccessResponse {
  message: string; // Message key from the backend
  interpolation?: { [key: string]: string }; // Interpolation object
}

export const handoverAccessApi = createApi({
  reducerPath: 'handoverAccessApi',
  baseQuery: customHandoverBaseQuery,
  endpoints: builder => ({
    updateHandoverAccess: builder.mutation<UpdateHandoverAccessResponse, UpdateHandoverAccessRequest>({
      query: ({ handoverId, ...data }) => ({
        url: HANDOVER_ACCESS_END_POINTS.updateHandoverAccess.replace(':handoverId', handoverId),
        method: METHOD.PUT,
        body: data,
      }),
      // Capture the message and interpolation from the server response
      transformResponse: (response: { message: string; interpolation?: { [key: string]: string } }) => ({
        message: response.message,
        interpolation: response.interpolation, // Capture interpolation data
      }),
    }),
  }),
});

export const { useUpdateHandoverAccessMutation } = handoverAccessApi;
